$(document).ready(function () {

  window.haveProductsWithCustomisations = false;
  window.selectedToBeSentFirst = {
          "Trouser": 0,
          "Suit": 0,
          "Shirt": 0,
          "Jacket": 0,
          "Waistcoat": 0,
          "Chino": 0,
          "Overcoat": 0
  };
  window.allowedCategories = [
          "Trouser",
          "Suit",
          "Shirt",
          "Jacket",
          "Waistcoat",
          "Chino",
          "Overcoat",
        ];
  window.cartCategories = [];
  window.cartUpdate = [];

  setSendFirst()
  
});



/* updating send first after switching toggle */ 

$(".send_first span").on("click", function () {

  let category = $(this).closest('.cart-item').attr("product-type");
  $(this).closest(".send_first").toggleClass("active");
  let index = $(this).closest(".send_first").attr("data-index");
  let sendFirst = 'Make first';
  if (!$(this).closest(".send_first").hasClass("active")) sendFirst = 'On hold';
    
  var properties = {};
    if (sendFirst === 'Make first') {
      window.selectedToBeSentFirst[category]++;
    } else {
      window.selectedToBeSentFirst[category]--;
    }
  
    $(this)
      .closest(".cart-item__details")
      .find("dl")
      .find(".product-option")
      .each(function (index, element) {
        let item = $(element).find("dt").html().replaceAll(": ", ""),
        value = $(element).find("dd").html();
        properties[item] = value;
      })
      .promise()
      .done(function () {
        properties['Status'] = sendFirst;
        $.post("/cart/change.js", {
          line: index,
          properties: properties,
        }).done(function () {
          validateCartStatus();
        });
      });
});

$("#coupon").on("click", function (event) {
  event.preventDefault();
  trackBeginCheckoutEspixel();
  var theUrl = "/checkout";
  var theDiscount = $("#coupon-code").val();
  let toRedirect = '';
  if (theDiscount != "") {
     toRedirect = theUrl + "?discount=" + theDiscount;
  } else {
     toRedirect = theUrl;
  }
 
  //redirect
  window.location.href = toRedirect;
});

function trackBeginCheckoutEspixel() {
  if (window.trackEspixel) {
    window.trackEspixel('beginCheckout', {
      total: ($('#revy-cart-subtotal-price').text() || $('.totals__subtotal-value').text() || '').trim()
    });
  }
}

$(document).on('click', '[name="checkout"], #checkout', function () {
  trackBeginCheckoutEspixel();
});

/* cart logic */

let categoryPriorities = {
  Suit: 1,
  Shirt: 2,
  Jacket: 3,
  Trouser: 4,
  Chino: 5,
  Waistcoat: 6,
  Overcoat: 7,
};

function disableCategory(category) {

  $('.cart-item[product-type="' + category + '"]').each(function () {
   
    let index = $(this).find(".send_first").attr("data-index");
    if ($(this).find(".send_first").hasClass("active")) {
     $(this).find(".send_first").removeClass("active");
      let properties = {};
      $(this)
      .find(".cart-item__details")
      .find("dl")
      .find(".product-option")
      .each(function (index, element) {
        let item = $(element).find("dt").html().replaceAll(": ", ""),
        value = $(element).find("dd").html();
        properties[item] = value;
      })
      .promise()
      .done(function () {
        properties['Status'] = 'On hold';
        window.cartUpdate.push({
          line: index,
          properties: properties,
        })
        window.selectedToBeSentFirst[category]--;
      });   
    }
  });
 
}
function disableDuplicates(category) {
  
  let i = 0;
  $('.cart-item[product-type="' + category + '"]').each(function () {
    let index = $(this).find(".send_first").attr("data-index"); 
      let properties = {};
      let element = $(this);
      $(this)
      .find(".cart-item__details")
      .find("dl")
      .find(".product-option")
      .each(function (index, element) {
        let item = $(element).find("dt").html().replaceAll(": ", ""),
        value = $(element).find("dd").html();
        properties[item] = value;
      })
      .promise()
      .done(function (element) {
        if (i === 0) {
          properties['Status'] = 'Make first'; 
        } else {
        properties['Status'] = 'On hold';   
        $(this).closest('.cart-item').find(".send_first").removeClass("active");
        window.selectedToBeSentFirst[category]--;
      }
        
        window.cartUpdate.push({
          line: index,
          properties: properties,
        })

        
        
      });   
    i++; 
  });
}
async function setSendFirst() {
  
  let cartItems = document.querySelectorAll("#main-cart-items .cart-item");
 
  let productTypes = [];

  $(cartItems).each(function () {
    
    let priority = 100;
    let category = $(this).attr("product-type");

    if (!window.cartCategories.includes(category)) window.cartCategories.push(category);
    window.selectedToBeSentFirst[category]++;
    
    if (!window.allowedCategories.includes(category)) return;

    window.haveProductsWithCustomisations = true;
    
    if (
      productTypes.find((item) => item.category === category) === undefined &&
      $(this).attr("product-type") !== undefined
    ) {
      if (categoryPriorities[category]) {
        priority = categoryPriorities[category];
      }
      productTypes.push({ category: category, priority: priority });
    }
  }).promise().then(function() {
    
    
     for (let cc of window.cartCategories){

        if ($('.cart-item[product-type="' + cc + '"]').length < 2) {
          $('.cart-item[product-type="' + cc + '"]').find('.send_first').hide();
        }
      }
    if(window.haveProductsWithCustomisations) {
      if ($('.send_first:visible').length > 0) {
        $('.cart_heading').css('padding', '40px').css('border', '1px solid #E2E2E2');
      $('.onlyCustomisable').show();
      } else {
        $('.note_description').show();
      }
      
    }
  });

  productTypes.sort(function (a, b) {
    return a.priority - b.priority;
  });

  for (let pt of productTypes) {
    if (
      (pt.category === "Trouser" ||
        pt.category === "Jacket" ||
        pt.category === "Chino") &&
      productTypes.find((item) => item.category === "Suit") !== undefined
    ) {
      disableCategory(pt.category);
    }
    else if (
      pt.category === "Chino" &&
      productTypes.find((item) => item.category === "Trouser") !== undefined
    ) 
    {
      disableCategory(pt.category);
    }
    else {
      disableDuplicates(pt.category);  
    }
     
    
    
  }

  const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
  
  for (let cu of window.cartUpdate) {
  await $.post("/cart/change.js", {
          line: cu.line,
          properties: cu.properties,
  });
    await sleep(500);
  }
  validateCartStatus();
  
}


function checkCartMeasurements(customerMeasurements) {
  if (customerMeasurements === null) {
    return "auth";
  } 
  else if (customerMeasurements === 'none'){
   return "none"; 
  }else {
    customerMeasurements = JSON.parse(customerMeasurements);
    let cartItems = document.querySelectorAll("#main-cart-items .cart-item");
    let allPassed = true;

    $(cartItems).each(function () {
      let category = $(this).attr("product-type");
      if (
        window.allowedCategories.includes(category)
      ) {
        if (category === "Trouser") category = "Pants";
        if (category === 'Chino') category = 'Chinos';
        if (category === "Suit") {
          if (
            !customerMeasurements.includes("Jacket") ||
            !customerMeasurements.includes("Pants")
          )
            allPassed = false;
        } else {
          if (!customerMeasurements.includes(category)) allPassed = false;
        }
      } else {
        $(this).find(".send_first").hide();
      }
    });

    return allPassed;
  }
}

function validateCartStatus() {

  $('#checkout').prop('disabled', false);
  $('.checkout_send_first').hide();
  let showNotice = false;
  if (window.cartCategories.includes('Suit') && window.selectedToBeSentFirst['Suit'] < 1) showNotice = true;
  if (window.cartCategories.includes('Shirt') && window.selectedToBeSentFirst['Shirt'] < 1) showNotice = true;
  if (window.cartCategories.includes('Jacket') && !window.cartCategories.includes('Suit') && window.selectedToBeSentFirst['Jacket'] < 1) showNotice = true;
  if (window.cartCategories.includes('Trouser') && !window.cartCategories.includes('Suit') && window.selectedToBeSentFirst['Trouser'] < 1) showNotice = true;
  //if (window.cartCategories.includes('Chino') && !window.cartCategories.includes('Suit') && window.selectedToBeSentFirst['Chino'] < 1) showNotice = true;
  if (showNotice) {
    $('#checkout').prop('disabled', true);
      $('.checkout_send_first').show();
  }
   
}

